export const updateDatiPremioCapitaleAssicurato = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};
